
import { useState } from 'react';
import { supabase } from '../../../utils/supabase';

interface HelpfulFeedbackProps {
  postId: string;
  currentCount: number;
}

export default function HelpfulFeedback({ postId, currentCount }: HelpfulFeedbackProps) {
  const [voted, setVoted] = useState(false);
  const [count, setCount] = useState(currentCount);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleVote = async (isHelpful: boolean) => {
    if (voted || isSubmitting) return;
    setIsSubmitting(true);

    try {
      if (isHelpful) {
        const { error } = await supabase
          .from('blog_posts')
          .update({ helpful_count: count + 1 })
          .eq('id', postId);

        if (!error) {
          setCount((prev) => prev + 1);
        } else {
          console.error('Supabase update error:', error);
        }
      }
      setVoted(true);
    } catch (err) {
      console.error('Erro ao registrar feedback:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (voted) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center">
        <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3">
          <i className="ri-heart-fill text-2xl text-green-600"></i>
        </div>
        <p className="text-green-800 font-semibold text-base">Obrigado pelo seu feedback!</p>
        <p className="text-green-600 text-sm mt-1">
          {count} {count === 1 ? 'pessoa achou' : 'pessoas acharam'} este artigo útil
        </p>
      </div>
    );
  }

  return (
    <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-6 text-center">
      <p className="text-neutral-800 font-semibold text-base mb-1">Este artigo foi útil?</p>
      <p className="text-neutral-500 text-sm mb-5">
        {count} {count === 1 ? 'pessoa achou' : 'pessoas acharam'} este artigo útil
      </p>
      <div className="flex items-center justify-center gap-3">
        <button
          onClick={() => handleVote(true)}
          disabled={isSubmitting}
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary text-white font-medium rounded-lg hover:bg-primary-700 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50"
        >
          <i className="ri-thumb-up-line"></i>
          Sim, foi útil
        </button>
        <button
          onClick={() => handleVote(false)}
          disabled={isSubmitting}
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-white border border-neutral-300 text-neutral-700 font-medium rounded-lg hover:bg-neutral-50 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50"
        >
          <i className="ri-thumb-down-line"></i>
          Não
        </button>
      </div>
    </div>
  );
}
